import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {getFormBodiesByBodyTypeId} from '../../../../../actions/FormData/formdataactions';
import {formBodyType} from '../../../../../util/uiconstants';
import RiskFactorsRedirectLink from '../RiskFactorsLink/RiskFactorsRedirectLink';
import {useDocumentId, useEngagementId} from '../../../../../util/customHooks';

export default function RedirectLinkContainer({headerId, sectionId}) {
	const dispatch = useDispatch();
	const documentId = useDocumentId();
	const engagementId = useEngagementId();

	let riskFactorsSlice = useSelector((state) => state.aresFormDataByBodyTypeId);

	useEffect(() => {
		let queryParams = {
			bodyTypeList: formBodyType.RelateRiskFactor,
			includeRelatedTask: true,
			filterIsSystemAssociatedTask: true
		};

		dispatch(getFormBodiesByBodyTypeId(engagementId, documentId, headerId, sectionId, queryParams));
	}, []);

	let hasRiskFactors = riskFactorsSlice?.allIds?.length > 0;

	return (
		<StyledRedirectLinkContainer>
			{hasRiskFactors && <RiskFactorsRedirectLink engagementId={engagementId} />}
		</StyledRedirectLinkContainer>
	);
}

RedirectLinkContainer.propTypes = {
	headerId: PropTypes.number,
	section: PropTypes.number
};

const StyledRedirectLinkContainer = styled.section``;
